import { Box, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { PhotoToModerate } from 'components/IncidentsMap/SearchDrawer/components/PhotoToModerate';
import { useModerationReports } from 'components/IncidentsMap/SearchDrawer/hooks/useModerationReports';
import { useSearchDrawerTabs } from 'components/IncidentsMap/SearchDrawer/hooks/useSearchDrawerTabs';
import { InlineStatus } from 'components/InlineStatus';
import { useAllGeoEvents } from 'features/geoEvents/hooks/useAllGeoEvents';

export const PhotoModeration = (): JSX.Element => {
  const showPhotosTab = useSearchDrawerTabs();
  const {
    reports,
    reportsCount,
    reportsError,
    reportsIsError,
    reportsIsLoading,
  } = useModerationReports();
  const { allGeoEvents } = useAllGeoEvents({ enabled: showPhotosTab });
  const { t } = useTranslation();

  const defaultEventName = t(
    'home.searchDrawer.photoModeration.unknownGeoEvent',
  );

  let content: JSX.Element;
  if (!showPhotosTab) {
    content = (
      <InlineStatus
        status="error"
        fullWidth
        errorMessage={t('unauthorized.description')}
      />
    );
  } else if (reportsIsLoading) {
    content = <InlineStatus status="loading" />;
  } else if (reportsIsError || reports == null) {
    content = (
      <InlineStatus status="error" errorMessage={reportsError?.message} />
    );
  } else if (reportsCount === 0) {
    content = (
      <Typography>
        {t('home.searchDrawer.photoModeration.noPhotosInViewport')}
      </Typography>
    );
  } else {
    content = (
      <Grid container columns={2} spacing={1}>
        {reports.map((report) => {
          const geoEvent = (allGeoEvents ?? []).find(
            (event) => event?.id === report.geoEventId,
          );
          const geoEventName = geoEvent?.name ?? defaultEventName;

          return (
            <PhotoToModerate
              key={report.id}
              report={report}
              geoEventName={geoEventName}
            />
          );
        })}
      </Grid>
    );
  }

  return <Box sx={{ m: 1 }}>{content}</Box>;
};
